import React from 'react';

// ICONS
import SvgIcon from '@material-ui/core/SvgIcon';
import ComputerIcon from '@material-ui/icons/Computer';
import InfoIcon from '@material-ui/icons/Info';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import MapIcon from '@material-ui/icons/Map';
import CodeIcon from '@material-ui/icons/Code';
import LinkIcon from '@material-ui/icons/Link';
import WebIcon from '@material-ui/icons/Web';
import MailIcon from '@material-ui/icons/Mail';
import Twitter from '@material-ui/icons/Twitter';
import { ReactComponent as FacebookIcon } from '../assets/icons/facebook.svg';
import { ReactComponent as GitHubIcon } from '../assets/icons/github.svg';
import { ReactComponent as LinkedInIcon } from '../assets/icons/linkedin.svg';
import { ReactComponent as CppIcon } from '../assets/icons/cplusplus-plain.svg';
import { ReactComponent as JavaIcon } from '../assets/icons/java-plain-wordmark.svg';
import { ReactComponent as AngularIcon } from '../assets/icons/angularjs-plain-wordmark.svg';
import { ReactComponent as JavaScriptIcon } from '../assets/icons/javascript-plain.svg';
import { ReactComponent as MongoDBIcon } from '../assets/icons/mongodb-plain-wordmark.svg';
import { ReactComponent as MySQLIcon } from '../assets/icons/mysql-plain-wordmark.svg';
import { ReactComponent as NodejsIcon } from '../assets/icons/nodejs-plain-wordmark.svg';
import { ReactComponent as PHPIcon } from '../assets/icons/php-plain.svg';
import { ReactComponent as ReactIcon } from '../assets/icons/react-original-wordmark.svg';
import { ReactComponent as TypeScriptIcon } from '../assets/icons/typescript-plain.svg';
import { ReactComponent as GraphQLIcon } from '../assets/icons/graphql.svg';

//Lexys icons
import { ReactComponent as ApacheIcon } from '../assets/icons/apache.svg';
import { ReactComponent as AudacityIcon } from '../assets/icons/audacity.svg';
import { ReactComponent as BashIcon } from '../assets/icons/bashh.svg';
import { ReactComponent as CIcon } from '../assets/icons/c.svg';
import { ReactComponent as CSSIcon } from '../assets/icons/css.svg';
import { ReactComponent as DaskIcon } from '../assets/icons/dask.svg';
import { ReactComponent as DockerIcon } from '../assets/icons/docker.svg';
import { ReactComponent as EducationIcon } from '../assets/icons/education.svg';
import { ReactComponent as GimpIcon } from '../assets/icons/gimp.svg';
import { ReactComponent as GitIcon } from '../assets/icons/git.svg';
import { ReactComponent as HTMLIcon } from '../assets/icons/html.svg';
import { ReactComponent as InkscapeIcon } from '../assets/icons/inkscape.svg';
import { ReactComponent as KdenliveIcon } from '../assets/icons/kdenlive.svg';
import { ReactComponent as NumpyIcon } from '../assets/icons/numpy.svg';
import { ReactComponent as PythonIcon } from '../assets/icons/python.svg';
import { ReactComponent as OrcidIcon } from '../assets/icons/orcid.svg';

import { ReactComponent as LinuxIcon } from '../assets/icons/linux.svg';
import { ReactComponent as WindowsIcon } from '../assets/icons/windows.svg';
import { ReactComponent as MacosIcon } from '../assets/icons/macos.svg';
import { ReactComponent as TrelloIcon } from '../assets/icons/trello.svg';
import { ReactComponent as CicdIcon } from '../assets/icons/cicd.svg';
import { ReactComponent as HobbiesIcon } from '../assets/icons/hobbies.svg';
import { ReactComponent as AwardsIcon } from '../assets/icons/awards.svg';
import { ReactComponent as ResearchIcon } from '../assets/icons/research.svg';

// ICONS END

/** Default icons */
const Icons = {
    email: <MailIcon />,
    facebook: <SvgIcon component={FacebookIcon} />,
    twitter: <Twitter />,
    github: <SvgIcon component={GitHubIcon} stroke="currentColor" strokeWidth={2} style={{ fill: 'none' }} title="GitHub"/>,
    linkedin: <SvgIcon component={LinkedInIcon} />,
    projects: <ComputerIcon />,
    about: <InfoIcon />,
    cpp: <SvgIcon component={CppIcon} viewBox="0 0 128 128" fontSize="large" title="C++" />,
    java: <SvgIcon component={JavaIcon} viewBox="0 0 128 128" fontSize="large" title="Java" />,
    typescript: <SvgIcon component={TypeScriptIcon} viewBox="0 0 128 128" fontSize="large" title="TypeScript" />,
    javascript: <SvgIcon component={JavaScriptIcon} viewBox="0 0 128 128" fontSize="large" title="JavaScript" />,
    mysql: <SvgIcon component={MySQLIcon} viewBox="0 0 128 128" fontSize="large" title="MySQL" />,
    php: <SvgIcon component={PHPIcon} viewBox="0 0 128 128" fontSize="large" title="PHP" />,
    mongodb: <SvgIcon component={MongoDBIcon} viewBox="0 0 128 128" fontSize="large" title="MongoDB" />,
    nodejs: <SvgIcon component={NodejsIcon} viewBox="0 0 128 128" fontSize="large" title="Node.js" />,
    react: <SvgIcon component={ReactIcon} viewBox="0 0 128 128" fontSize="large" title="React" />,
    angular: <SvgIcon component={AngularIcon} viewBox="0 0 128 128" fontSize="large" title="Angular" />,
    graphql: <SvgIcon component={GraphQLIcon} viewBox="0 0 400 400" fontSize="large" title="GraphQL" />,
    helpoutline: <HelpOutlineIcon />,
    map: <MapIcon />,
    code: <CodeIcon />,
    link: <LinkIcon />,
    web: <WebIcon />,
    apache: <SvgIcon component={ApacheIcon} viewBox="0 0 30 30" fontSize="large" title="Apache" />,
    audacity: <SvgIcon component={AudacityIcon} viewBox="0 0 30 30" fontSize="large" title="Audacity" />,
    bash: <SvgIcon component={BashIcon} viewBox="0 0 20 20" fontSize="large" title="Bash" />,
    css: <SvgIcon component={CSSIcon} viewBox="0 0 800 800" fontSize="large" title="CSS" />,
    c: <SvgIcon component={CIcon} viewBox="0 0 800 800" fontSize="large" title="C" />,
    dask: <SvgIcon component={DaskIcon} viewBox="0 0 1056 400" fontSize="large" title="Dask" />,
    docker: <SvgIcon component={DockerIcon} viewBox="0 0 30 30" fontSize="large" title="Docker" />,
    education: <SvgIcon component={EducationIcon} viewBox="0 250 1100 900" fontSize="large" title="Education" />,
    gimp: <SvgIcon component={GimpIcon} viewBox="0 0 30 30" fontSize="large" title="Gimp" />,
    git: <SvgIcon component={GitIcon} viewBox="0 0 30 30" fontSize="large" title="Git" />,
    html: <SvgIcon component={HTMLIcon} viewBox="0 0 800 800" fontSize="large" title="HTML" />,
    inkscape: <SvgIcon component={InkscapeIcon} viewBox="0 0 30 30" fontSize="large" title="Inkscape" />,
    kdenlive: <SvgIcon component={KdenliveIcon} viewBox="0 0 10 18" fontSize="large" title="Kdenlive" />,
    numpy: <SvgIcon component={NumpyIcon} viewBox="0 0 30 30" fontSize="large" title="Numpy" />,
    python: <SvgIcon component={PythonIcon} viewBox="0 0 30 30" fontSize="large" title="Python" />,
    orcid: <SvgIcon component={OrcidIcon} viewBox="-3.5 -3.5 30 30" fontSize="large" title="Orcid" />,


    linux: <SvgIcon component={LinuxIcon} viewBox="0 0 18 18" fontSize="large" title="Linux" />,
    windows: <SvgIcon component={WindowsIcon} viewBox="0 0 30 30" fontSize="large" title="Windows" />,
    macos: <SvgIcon component={MacosIcon} viewBox="0 0 40 40" fontSize="large" title="MacOS" />,
    trello: <SvgIcon component={TrelloIcon} viewBox="0 0 60 60" fontSize="large" title="Trello" />,
    cicd: <SvgIcon component={CicdIcon} viewBox="0 0 40 40" fontSize="large" title="CI/CD" />,
    awards: <SvgIcon component={AwardsIcon} viewBox="0 0 65 65" fontSize="large" />,
    research: <SvgIcon component={ResearchIcon} viewBox="0 0 60 60" fontSize="large"/>,
    hobbies: <SvgIcon component={HobbiesIcon} viewBox="0 0 25 25" fontSize="large" />,
    // scipy: <SvgIcon component={ScipyIcon} viewBox="64 64 128 128" fontSize="large" title="Scipy" />,
};


export { Icons };